import log from "loglevel";

/** The UI's logger; `console` is not used directly. */
export const logger = log.getLogger("analyst-ui");
logger.setLevel(import.meta.env.DEV ? "debug" : "warn");
